import React from 'react'
import './Footer.css';
import { Link } from 'react-router-dom';
function Footer() {
  return (
    <footer>
        <div className='container'>
            <div className='d-flex justify-content-center'>
            <div>

            <div className='social'>
                <span><i className="fa-brands fa-facebook"></i></span>
                <span><i className="fa-brands fa-instagram"></i></span>
                <span><i className="fa-brands fa-twitter"></i></span>
                <span><i className="fa-brands fa-google-plus"></i></span>
                <span><i className="fa-brands fa-youtube"></i></span>
            </div>
            <ul className='navlink justify-content-center'>
                    <li><Link className='f-link' to="/">Home</Link></li>
                    <li><a className='f-link' href="/">Features</a></li>
                    <li><a className='f-link' href="/">Pricing</a></li>
                    <li><a className='f-link' href="/">Blog</a></li>
            </ul>
            <p className='text-center mt-3'>Copyright &copy; 2022; Designed by Aakash</p>
            </div>
            </div>
        </div>
    </footer>
  )
}

export default Footer